import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { LicenseDetails } from '@microsoft/microsoft-graph-types';
import { IUserTeamMembership } from '@nimbus-portal/features/personal/model/i-user-team-membership.model';
import { AcUserApiClient } from '@nimbus-portal/features/attendant-console/services/api/ac-user.api-client';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { AcUser, IAcTeamMembership } from '@nimbus-portal/features/attendant-console/model/ac-user/ac-user.model';
import { GraphUserApiClient } from '@nimbus-library/features/graph/services/graph-user.api-client';
import { guidRegexp } from '@nimbus-portal/features/attendant-console/model/ac.constants';

@Injectable({ providedIn: 'root' })
export class AcUserService {
  public constructor(
    private readonly acUserApiClient: AcUserApiClient,
    private readonly authenticationService: IAuthenticationService,
    private readonly graphUserApiClient: GraphUserApiClient,
  ) {}

  public getUser(): Observable<AcUser> {
    const userInfo = this.authenticationService.getUserInfo();
    return of({ id: userInfo.userId, displayName: userInfo.name } as AcUser);
  }

  public getLicenseInformation(): Observable<LicenseDetails[]> {
    return this.graphUserApiClient.getUserLicense();
  }

  public getTeamsMembership(): Observable<IAcTeamMembership> {
    return of({ nimbusActive: true, lucsActive: false, tmActive: false } as IAcTeamMembership);
  }

  public getMembershipsByUserId(userId: string): Observable<IUserTeamMembership[]> {
    if (!guidRegexp.test(userId)) {
      return of([]);
    }
    return this.acUserApiClient.getMembershipsByUserId(userId);
  }
}
